import React, { useRef } from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import InterestedInUsedGMC from './InterestedInUsedGMC';

const Used2015MercedesBenzCla250ForSaleInBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="2015 Mercedes-Benz CLA250 For Sale In Boerne & Austin, Texas at Mark Motors"
                description="The used 2015 Mercedes-Benz CLA250 for sale in Boerne & Austin, Texas at Mark Motors is one of three exceptional models in its class - the used 2015 Mercedes-Benz CLA250, CLA250 4MATIC, and CLA45 AMG."
                keywords="2015 Mercedes-Benz CLA250 For Sale in Boerne & Austin, Texas, 2015 Mercedes-Benz CLA250 Specials in Boerne & Austin, Texas, 2015 Mercedes-Benz CLA250 Dealer in Boerne & Austin, Texas, 2015 Mercedes-Benz CLA250 For Sale Near Boerne & Austin, Texas, 2015 Mercedes-Benz CLA250 in Boerne & Austin TX"
                ogTitle="2015 Mercedes-Benz CLA250 For Sale In Boerne & Austin, Texas at Mark Motors"
                ogDescription="The used 2015 Mercedes-Benz CLA250 for sale in Boerne & Austin, Texas at Mark Motors is one of three exceptional models in its class - the used 2015 Mercedes-Benz CLA250, CLA250 4MATIC, and CLA45 AMG."
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">

                        <h1><span className="s1"><strong>Used 2015 Mercedes-Benz CLA250 For Sale In Boerne, Texas at Mark Motors</strong></span></h1>
                        <p><span>The used 2015 Mercedes-Benz CLA250 for sale in Boerne, Texas brings you an artful design sure to inspire your eyes, and performance to feed your hunger. The used 2015 Mercedes-Benz CLA250 is one of three exceptional models in its class - the used 2015 Mercedes-Benz CLA250, CLA250 4MATIC, and CLA45 AMG. It is available in a full selection of bold exterior color options that include Jupiter Red, Cirrus White, Night Black, Cosmos Black Metallic, Northern Lights Violet Metallic, Polar Silver Metallic, Mountain Grey Metallic, Cocoa Brown Metallic, and Magno Polar Silver Matte. Visit us at Mark Motors in Boerne, Texas to check out our large stock of used 2015 Mercedes-Benz CLA250 vehicles for sale!</span>
                        </p>
                        <h2><span className="s1"><strong>Overview - 2015 Mercedes-Benz CLA250 For Sale Near Boerne, Texas</strong></span></h2>
                        <p><span><strong>&nbsp;</strong></span>
                            <span>2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span>
                            <span><strong>Engine</strong></span>
                            <span>2.0 I-4 Engine</span>
                            <span>208 HP @ 5500 rpm</span>
                            <span>258 @ 1,250 rpm Torque</span><span>&nbsp;</span>
                            <span><strong>Transmission</strong></span>
                            <span>7-Speed auto-shift manual w/OD and auto-manual</span>
                            <span><strong>Drive Type</strong></span>
                            <span>Front-Wheel Drive</span>
                            <span><strong>Efficiency</strong></span>
                            <span>26 city / 38 hwy / 32 combined mpg</span>
                            <span><strong>Wheelbase</strong></span>
                            <span>17-inch Alloy Wheels</span>
                        </p>
                        <h2><span className="s1"><strong>Exterior Features - 2015 Mercedes-Benz CLA250 Dealer In Boerne, Texas</strong></span></h2>
                        <p><span><strong>&nbsp;</strong></span>
                            <span>2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Available Colored Rear Bumper Insert.</span>
                            <span>Available Chrome Grille.</span>
                            <span>Available Power Remote Right Side-View Door Mirror with Tilt Down.</span>
                            <span>Body-Colored Door Handles.</span>
                            <span>Fully Galvanized Steel Body Material.</span>
                            <span>Available Spoiler.</span>
                            <span>Available Auto Dimming Power Remote Left Side-View Door Mirror.</span>
                            <span>Power Remote Heated Folding Side-View Door Mirrors with Turn Signal Indicator.</span>
                            <span>Available Colored Front Bumper Insert.</span>
                            <span>Turn Signal Indicator Mirrors.</span>
                            <span>Heated Door Mirrors.</span>
                            <span>Available Metallic Paint.</span>
                            <span>Power Door Mirrors.</span>
                            <span>4 Doors.</span>
                            <span>Available Paint with Badging.</span>
                            <span>Rear Cargo Trunk.</span>
                            <span>Grille with Chrome Bar.</span>
                            <span>Body-Colored Front and Rear Bumpers.</span>
                            <span>Available Rocker Panel Extensions.</span>
                            <span>Available Rear Lip Spoiler.</span>
                            <span>Available Heated Folding Side-View Door Mirrors with Turn Signal Indicators.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA250 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Interior Features - 2015 Mercedes-Benz CLA250 Specials In Boerne, Texas</strong></span></h2>
                        <p><span>2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span><span>&nbsp;</span>
                            <span><strong>Convenience</strong></span>
                            <span>Available Distance Pacing Cruise Control.</span>
                            <span>Available Cruise Control with DISTRONIC PLUS Distance Pacing.</span>
                            <span>Door Mirror Memory.</span>
                            <span>2 Setback Storage Pockets.</span>
                            <span>3 12V DC Power Outlets.</span>
                            <span>Power Windows with Front and Rear 1-Touch Down.</span>
                            <span>Emergency Communication System.</span>
                            <span>Driver Manual Folding Mirror.</span>
                            <span>Power Cargo Access Remote Release.</span>
                            <span>Available Sunshade.</span>
                            <span>Integrated Key/Remote.</span>
                            <span>Rear Door Bins.</span>
                            <span>Available Panoramic Sunroof.</span>
                            <span>Air Filter.</span>
                            <span>Day-Night Rearview Mirror.</span>
                            <span>Available Garage Door Transmitter.</span>
                            <span>Key fob (all doors) Remote Keyless Entry.</span>
                            <span>Full Floor Console.</span>
                            <span>Driver and Passenger Door Bins.</span>
                            <span>Front Dual Zone A/C.</span>
                            <span>Available Navigation System with Voice Activation.</span>
                            <span>Automatic Temperature Control.</span>
                            <span>Retained Accessory Power.</span>
                            <span>Available Navigation System.</span>
                            <span>Available Front and Rear Express Open/Close Sliding and Tilting Glass Sunroof.</span>
                            <span>Front and Rear Cupholders.</span>
                            <span>Proximity Key.</span>
                            <span>Cruise Control.</span>
                            <span>Illuminated Driver and Passenger-Side Visor Mirrors.</span>
                            <span>Remote Window Controls.</span>
                            <span>Available Remote Sunroof/Convertible Roof Controls.</span>
                            <span>Available Sunroof/Convertible Roof FOB Controls.</span>
                            <span>3 Memory Settings.</span>
                            <span>Front Underseat Storage Tray.</span>
                            <span>Illuminated Entry.</span>
                            <span>Passenger Manual Folding Mirror.</span>
                            <span>Steering Wheel with Manual Tilting, Manual Telescoping.</span>
                            <span>Available Power Glass Tilting and Sliding Sunroof.</span>
                            <span>Overhead Console.</span>
                            <span>Illuminated Passenger Vanity Mirror.</span>
                            <span>Mini Overhead Console with Storage.</span>
                            <span>Automatic Dual-Zone Front Air Conditioning.</span>
                            <span>1-Touch Down.</span>
                            <span>Available Sport Steering Wheel with Manual Tilting, Manual Telescoping.</span>
                            <span>Keyfob Trunk/Hatch/Door Release.</span>
                            <span>3 Driver Memory Seat Settings (includes door mirrors).</span>
                            <span>Illuminated Driver Vanity Mirror.</span>
                            <span>Console Ducts.</span>
                            <span>Available Power Sunshade.</span>
                            <span>Full Floor Console with Covered Box.</span>
                            <span>1-Touch Up.</span>
                            <span>Driver’s Footrest.</span>
                            <span>Auto-Locking Doors.</span>
                            <span>Available Auto-Dimming Rearview Mirror.</span>
                            <span>Memory Seats.</span>
                            <span>Telescoping Steering Wheel.</span>
                            <span>Illuminated Glove Box.</span>
                            <span>Tilt Steering Wheel.</span>
                            <span>&nbsp;</span>
                            <span>2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Seats and Trim</strong></span>
                            <span>8-Way Power Driver Seat.</span>
                            <span>Available Genuine Wood Instrument Panel Insert.</span>
                            <span>5 Max Seating Capacity.</span>
                            <span>Rear Seat Fold-Forward Setback.</span>
                            <span>Manual Passenger Fore/Aft Adjustment.</span>
                            <span>Available Aluminum Instrument Panel Insert.</span>
                            <span>Carpet Front and Rear Floor Mats.</span>
                            <span>Available Driver and Passenger Heated-Cushions.</span>
                            <span>Passenger Cushion Tilt.</span>
                            <span>Floor Mats.</span>
                            <span>Metal-Look Interior Accents.</span>
                            <span>Driver Cushion Tilt.</span>
                            <span>Available Aluminum and Metal-Look Interior Accents.</span>
                            <span>Cargo Light.</span>
                            <span>Front Center Armrest.</span>
                            <span>Metal-Look Instrument Panel Insert.</span>
                            <span>Available ARTICO Leatherette Door Panel Trim.</span>
                            <span>Cargo Tie-Downs.</span>
                            <span>Manual Height-Adjustable Passenger Seat.</span>
                            <span>Power 4-Way Driver Lumbar Support.</span>
                            <span>Available DINAMICA/MB-Tex Simulated Suede/Leatherette Front and Rear Seat Upholstery.</span>
                            <span>Front Sport Seats.</span>
                            <span>Available Leather Dashboard.</span>
                            <span>Urethane Shift Knob.</span>
                            <span>Available 8-Way Power Passenger Seat.</span>
                            <span>Full Cloth Headliner.</span>
                            <span>Carpet Cargo Space.</span>
                            <span>Leatherette Upholstery.</span>
                            <span>Concealed Cargo Storage.</span>
                            <span>Bucket Front Seats.</span>
                            <span>Height Adjustable Driver Seat.</span>
                            <span>MB-Tex Leatherette Front and Rear Upholstery.</span>
                            <span>Driver Lumbar Support.</span>
                            <span>Power Reclining Driver Seat.</span>
                            <span>Rear Bench Seat.</span>
                            <span>Available Leather Front and Rear Seat Upholstery.</span>
                            <span>Carpet Trunk Lid/Rear Cargo Door.</span>
                            <span>Available Sport Steering Wheel.</span>
                            <span>Available Leather/Simulated Suede Steering Wheel.</span>
                            <span>Available Power Passenger Cushion Tilt.</span>
                            <span>Rear Seat Center Armrest.</span>
                            <span>Available Driver and Passenger Heated-Seatbacks</span>
                            <span>Rear 60-40 Bench Seat.</span>
                            <span>Carpet Floor Covering.</span>
                            <span>Available Heated Front Seats.</span>
                            <span></span><span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA250 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Entertainment Features - 2015 Mercedes-Benz CLA250 Specials In Boerne, Texas</strong></span></h2>
                        <p><span><strong>&nbsp;</strong></span>
                            <span>2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Primary Monitor Touchscreen.</span>
                            <span>Digital Signal Processor.</span>
                            <span>2 1st Row LCD Monitors.</span>
                            <span>Wireless Phone Connectivity.</span>
                            <span>Available SiriusXM AM/FM/HD/Satellite with Seek-Scan, Single In-Dash CD Player.</span>
                            <span>Audio Theft Deterrent.</span>
                            <span>mbrace Mobile Application.</span>
                            <span>AM/FM Radio.</span>
                            <span>8 Speakers.</span>
                            <span>Steering Wheel Mounted Audio Controls.</span>
                            <span>450W Amplifier.</span>
                            <span>Window Grid Antenna.</span>
                            <span>Internet Access.</span>
                            <span>Available 12 Harman/Kardon Speakers.</span>
                            <span>Available 6-Disc CD Changer.</span>
                            <span>CD Player.</span>
                            <span>Radio Data System.</span>
                            <span>Available DVD-Audio.</span>
                            <span>Available Voice Activated Radio.</span>
                            <span>MP3 Decoder.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA250 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Lighting &amp; Instrumentation - 2015 Mercedes-Benz CLA250 Dealer In Boerne, Texas</strong></span></h2>
                        <p><span><strong>&nbsp;</strong></span>
                            <span>2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Fully Automatic Headlights.</span>
                            <span>Light-Tinted Windows.</span>
                            <span>Front and Rear Reading Lights.</span>
                            <span>Dome Light with Fade.</span>
                            <span>Outside Temperature Display.</span>
                            <span>Available Rear Camera.</span>
                            <span>Delay-Off Headlights.</span>
                            <span>Available Delay-Off Project Beam Bi-Xenon High Intensity Low/High Beam Headlamps.</span>
                            <span>Tire Specific Low-Tire-Pressure Warning.</span>
                            <span>Rear Fog Lights.</span>
                            <span>Trip Computer.</span>
                            <span>Available Compass.</span>
                            <span>Rear Window Defroster.</span>
                            <span>4 Door Curb/Courtesy Lights.</span>
                            <span>Variable Intermittent Rain Detecting Wipers with Heating Jets.</span>
                            <span>Systems Monitor.</span>
                            <span>Available Blind Spot Sensor.</span>
                            <span>Automated Reverse Sensing System.</span>
                            <span>Delay-Off Aero-Composite Halogen Headlamps.</span>
                            <span>Available PARKTRONIC w/Active Parking Assist Automated Parking Sensors.</span>
                            <span>Available Lane Departure.</span>
                            <span>Brake Pad Wear.</span>
                            <span>Trip Odometer.</span>
                            <span>Variable Instrument Panel Lighting.</span>
                            <span>In-Dash Clock.</span>
                            <span>Analog Display.</span>
                            <span>Available High Intensity Discharge Headlights.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz CLA250 vehicles for sale in Boerne, Texas.</span>
                        </p>
                        <h2><span className="s1"><strong>Dimensions &amp; Capacity - 2015 Mercedes-Benz CLA250 For Sale In Boerne, Texas</strong></span></h2>
                        <p><span><strong>&nbsp;</strong></span>
                            <span>Wheelbase: 106.3 in.</span>
                            <span>Front Legroom: 40.2 in.</span>
                            <span>Front Headroom: 38.2 in.</span>
                            <span>Maximum Interior Cargo Volume: 13.1 cu. ft.</span>
                            <span>Engine Horsepower: 208-hp @ 5500 rpm.</span>
                            <span>Interior Cargo Volume: 13.1 cu. ft.</span>
                            <span>Engine Bore x Stroke: 3.3 in. X 3.6 in.</span>
                            <span>Compression Ratio: 9.80 to 1.</span>
                            <span>Engine Type: I-4.</span>
                            <span>Payload: 1,070 lbs.</span>
                            <span>Valves: 16.</span>
                            <span>Front Shoulder Room: 56 in.</span>
                            <span>Front Tread: 60.9 in.</span>
                            <span>Ground Clearance (max): 3.9 in.</span>
                            <span>Fuel Economy Highway: 38 mpg.</span>
                            <span>Engine Torque: 258 lbs.-ft. @ 1,250 rpm.</span>
                            <span>Exterior Body Width: 70 in.</span>
                            <span>Drag Coefficient: .28</span>
                            <span>Turning Radius: 18 ft.</span>
                            <span>Rear Shoulder Room: 53.2 in.</span>
                            <span>Rear Legroom: 27.1 in.</span>
                            <span>Curb Weight: 3395 lbs.</span>
                            <span>Fuel Tank Capacity: 13.2 gal.</span>
                            <span>Valve Train: DOHC.</span>
                            <span>Engine Displacement: 121 cu. in.</span>
                            <span>Exterior Length: 182.3 in.</span>
                            <span>Exterior Height: 56.6 in.</span>
                            <span>Rear Tread: 60.8 in.</span>
                            <span><strong>&nbsp;</strong></span>
                        </p>
                        <h2><span className="s1"><strong>A Show Of Emotion - 2015 Mercedes-Benz CLA250 In Boerne, Texas</strong></span></h2>

                        <img src={getImages('new/2015-CLA-Class-250-2-1.jpg')} alt='2015 Mercedes-Benz C250 For Sale In Boerne, Texas' />

                        <p><span>The used 2015 Mercedes-Benz CLA250 for sale in Boerne, Texas at Mark Motors is packed with standard features that are sure to impress you, including standard 17-inch alloy wheels, leatherette upholstery, keyless ignition, and much more. From its solid stance to the tensed uncle in its profile, the used 2015 Mercedes-Benz for sale in Boerne, Texas ensures that you see and feel its love of the road. Visit Mark Motors in Boerne, Texas to test drive your used 2015 Mercedes-Benz CLA250 available for sale. Our team of experience professionals are always available to answer any questions and help you find exactly what you’re looking for.</span>
                            <span><span className="s1">Used 2015 Mercedes-Benz CLA250 for sale in Boerne, Texas.</span>&nbsp;</span>
                            <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
                            <span>See dealer or owner's literature for limited warranty details.</span>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Used2015MercedesBenzCla250ForSaleInBoerneTexas